// TS port of app/lib/gain-curve.mjs — canonical pair.
// Math identical, both sides have mirror tests. If you edit one, edit the other.
export const DB_MIN = -60;
export const DB_MAX = 20;
export const POS_UNITY = (0 - DB_MIN) / (DB_MAX - DB_MIN); // = 0.75
export const DB_MAX_FACTOR = Math.pow(10, DB_MAX / 20); // = 10
export function positionToFactor(pos) {
    if (!(pos > 0))
        return 0;
    if (pos >= 1)
        return DB_MAX_FACTOR;
    const db = DB_MIN + (DB_MAX - DB_MIN) * pos;
    return Math.pow(10, db / 20);
}
export function factorToPosition(factor) {
    if (!(factor > 0))
        return 0;
    const db = 20 * Math.log10(factor);
    if (db <= DB_MIN)
        return 0;
    if (db >= DB_MAX)
        return 1;
    return (db - DB_MIN) / (DB_MAX - DB_MIN);
}
export function formatDb(factor) {
    if (!(factor > 0))
        return '−∞ dB';
    const db = 20 * Math.log10(factor);
    if (db <= DB_MIN)
        return '−∞ dB';
    return (db >= 0 ? '+' : '') + db.toFixed(1) + ' dB';
}
export function applyDbStep(currentFactor, deltaDb) {
    if (currentFactor <= 0) {
        if (deltaDb <= 0)
            return 0;
        return positionToFactor(deltaDb / (DB_MAX - DB_MIN));
    }
    const db = 20 * Math.log10(currentFactor) + deltaDb;
    if (db <= DB_MIN)
        return 0;
    if (db >= DB_MAX)
        return DB_MAX_FACTOR;
    return Math.pow(10, db / 20);
}
//# sourceMappingURL=gain-curve.js.map